import {Component, Input, OnInit, Output, EventEmitter, ViewChildren, QueryList} from '@angular/core';
import {Options} from './options';
import {MatSlider} from '@angular/material/slider';
import * as _ from 'lodash';
import {GameSize} from '../../verliba-shared';

@Component({
  selector: 'app-options',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.css']
})
export class OptionsComponent implements OnInit {
  @Input() options: Options;
  @Output() changed = new EventEmitter<Options>();
  @Output() loaded = new EventEmitter<void>();

  @ViewChildren(MatSlider)
  sliders: QueryList<MatSlider>;

  constructor(
    private gameSize: GameSize
  ) {
    this.save = _.throttle(this.save.bind(this), 500);
  }

  get width(): number {
    return this.gameSize.width;
  }

  ngOnInit(): void {
    setTimeout(() => this.load(), 100);
  }

  onChange(): void {
    this.sliders.forEach(slider => slider.blur());
    this.changed.emit(this.options);
    this.save();
  }

  get style(): any {
    return {
      width: `${this.width}px`,
    };
  }

  save(): void {
    localStorage.setItem('snake-options', JSON.stringify(this.options));
  }

  load(): void {
    const options = JSON.parse(localStorage.getItem('snake-options') || '{}');
    console.log(options);
    Object.assign(this.options, options);
    this.loaded.emit();
  }
}
